import styled from 'styled-components'
import { Borders, FontWeights } from '../../constants'

export const Amount = styled.span`
  font-size: 18px;
  font-weight: ${FontWeights.Bold};
`

export const TokenAmount = styled.div`
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${Borders.Color};
  border-radius: ${Borders.Radius};
`

export const TokenAmountReceive = styled(TokenAmount)`
  background: rgb(234, 241, 253);
`

export const Symbol = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: ${FontWeights.Bold};
`
